import { BreadCrumb } from "primereact/breadcrumb";
import { routes } from "../../../routes";
import { useEffect, useRef, useState } from "react";
import { FilterMatchMode } from "primereact/api";
import SearchComponent from "../../../components/datatable/SearchComponent";
import { Button } from "primereact/button";
import ActionBtn from "../../../components/dashboard/btn/ActionBtn";
import GeneralTestService from "../../../api/GeneralTestService";
import TrainingService from "../../../api/TrainingService";
import { Toast } from "primereact/toast";
import DeleteConfirmation from "../../../components/modal/DeleteConfirmation";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import { useNavigate } from "react-router-dom";

export default function GeneralTest() {
  const navigate = useNavigate();
  const items = [
    {
      label: "Test de developpement Personnel",
      url: routes.dashboard.generalTest.path,
    },
    { label: "Liste" },
  ];
  const candidate = {
    icon: "pi pi-wallet",
    url: routes.dashboard.statistic.path,
  };

  const [classroom, setClassroom] = useState("");
  const [refresh, setRefresh] = useState(true);
  const [loading, setLoading] = useState(false);

  const [classrooms, setClassrooms] = useState([]);
  const [tests, setTests] = useState([]);
  const [test, setTest] = useState();
  const [question, setQuestion] = useState("");
  const [description, setDescription] = useState("");
  const toast = useRef(null);
  const [confirm, setConfirm] = useState(false);
  const [addVisible, setAddVisible] = useState(false);
  const [updateVisible, setUpdateVisible] = useState(false);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const header = () => {
    return (
      <div className="flex justify-content-between">
        <Button
          icon="pi pi-plus"
          label="Ajouter un test"
          onClick={() => setAddVisible(true)}
        />
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="flex flex-wrap justify-content-start gap-3">
        <ActionBtn
          icon="pi pi-eye"
          severity="primary"
          tooltip="Voir les propositions de réponses"
          handleClick={() =>
            navigate(`/generalTest/${rowData.id}/proposals`)
          }
        />
        {/*  <ActionBtn
            icon="pi pi-pencil"
            severity="info"
            tooltip="Modifier"
            handleClick={()=>updateRequirement(rowData)}
          /> */}
        <ActionBtn
          icon="pi pi-trash"
          severity="danger"
          tooltip="Supprimer"
          handleClick={() => confirmDelete(rowData.id)}
        />
      </div>
    );
  };

  const updateStatus = (e, rowData) => {
    console.log("e.value", e.value);
    let data = rowData;
    data.status = e.value == "Oui" ? "yes" : "no";
    GeneralTestService.update(rowData.id, data).then((res) => {
      setRefresh(!refresh);
    });
  };
  const updateRequirement = (rowData) => {
    GeneralTestService.update(rowData.id, rowData).then((res) => {
      setRefresh(!refresh);
    });
  };

  const addTest = (e) => {
    e.preventDefault();
    if (!classroom || !question) {
      toast.current.show({
        severity: "error",
        summary: "Stop",
        detail: "Veuillez remplir tous les champs",
        life: 3000,
      });
    } else {
      const data = {
        test: question,
        description: description,
        training_program_id: classroom.id,
      };
      GeneralTestService.create(data)
        .then((res) => {
          //console.log("res", res)
          setRefresh(!refresh);
          setAddVisible(false);
        })
        .catch((err) => console.log("err", err));
    }
  };
  const deleteTest = () => {
    GeneralTestService.delete(test)
      .then((res) => {
        toast.current.show({
          severity: "info",
          summary: "Succèss",
          detail: "Test supprimé avec succès",
          life: 3000,
        });
        setRefresh(!refresh);
      })
      .catch((err) => {});
  };
  const rejectConfirmation = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulé",
      detail: "Vous aviez annulé la suppression",
      life: 3000,
    });
  };
  const confirmDelete = (id) => {
    setTest(id);
    setConfirm(true);
  };

  useEffect(() => {
    TrainingService.getAll().then((res) => {
      setClassrooms(res.data.trainingPrograms);
    });
    GeneralTestService.getAll().then((res) => {
      setTests(res.data.generalTests);
    });
  }, [refresh]);

  return (
    <div>
      <Toast ref={toast} />
      <DeleteConfirmation
        visible={confirm}
        onHide={() => setConfirm(false)}
        message={`Voulez-vous réellement supprimé le test ${
          tests?.filter((rol) => rol.id === parseInt(test))[0]?.test
        } ?`}
        accept={deleteTest}
        reject={rejectConfirmation}
      />
      <Dialog
        header="Ajouter un pré-requis"
        visible={addVisible}
        style={{ width: "50vw" }}
        onHide={() => setAddVisible(false)}
      >
        <form className="form" onSubmit={addTest}>
          <div className="form__item">
            <label htmlFor="site">Parcours</label>
            <div className="form__item__ic_p">
              <Dropdown
                value={classroom}
                onChange={(e) => {
                  setClassroom(e.value);
                }}
                options={classrooms}
                optionLabel="name"
                placeholder="Sectionner un parcours"
                className="w-full"
              />
            </div>
          </div>
          <div className="form__item">
            <label htmlFor="name">Question</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="name"
                label="name"
                handleChange={(e) => setQuestion(e.target.value)}
                // register={register}
              />
            </div>
          </div>
          <div className="form__item">
            <label htmlFor="description">Description (Optionnel)</label>
            <div className="form__item__ic_p">
              <InputTextarea
                id={"description"}
                onChange={(e) => setDescription(e.target.value)}
                //{...register("description")}
                rows={4}
                //cols={30}
                className="w-full"
              />
            </div>
          </div>
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <div>
        <BreadCrumb model={items} home={candidate} />
      </div>
      <div>
        <div>
          <DataTable
            header={header}
            value={tests}
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column
              field="training_program.name"
              header="Parcours"
              //body={actionTemplate}
            ></Column>
            <Column field="test" header="Question"></Column>
            <Column
              field="description"
              header="Description"
              body={(row) => (row.description ? row.description : "N/A")}
            ></Column>
            <Column header="Actions" body={actionTemplate}></Column>
          </DataTable>
        </div>
      </div>
    </div>
  );
}
